module.exports = __webpack_public_path__ + "img/PRC_282010002.ASM.602534cf.png";